import axios from 'axios';
import { deleteItemsFromLocalStorage } from '@/services/functions';

const VUE_APP_AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL;

const isLocal = process.env.VUE_APP_ENV === 'local';

const TOKEN_MAP = {
  accessToken: 'access_token',
  refreshToken: 'refresh_token',
  idToken: 'id_token',
};

export const getAccessTokenHandler = async () => {
  try {
    const refreshToken = localStorage.getItem('refreshToken');

    const requestBody = isLocal
      ? {
          ...(refreshToken && { refresh_token: refreshToken }),
          returnTokens: true,
        }
      : {};

    const response = await axios.post(
      `${VUE_APP_AUTH_BASE_URL}/authorization/refresh-token`,
      requestBody,
      { withCredentials: true }
    );

    if (isLocal) {
      Object.entries(TOKEN_MAP).forEach(([localKey, responseKey]) => {
        const value = response.data?.[responseKey];
        if (value) {
          localStorage.setItem(localKey, value);
        }
      });
    }

    return response.data.success ? 'authenticated' : null;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      deleteItemsFromLocalStorage([
        'userType',
        'integrationsCount',
        ...(!isLocal ? [] : Object.keys(TOKEN_MAP)),
      ]);
      return null;
    }

    console.log(error, 'error');
    return null;
  }
};
